import { Language } from '@/contexts/LanguageContext';

/**
 * Public site is English-only at clean root URLs (no /en or /el prefix).
 * Legacy /en/* and /el/* are 301-redirected at Netlify edge.
 * These helpers now just normalise paths — they no longer add a language prefix.
 */

function stripLangPrefix(path: string): string {
  // Strip leading /el or /en if present, then leading slash
  const noLang = path.replace(/^\/(el|en)(?=\/|$)/, '');
  return noLang.replace(/^\//, '');
}

/** Returns a clean root path like "/pricing" regardless of input. */
export function getLocalizedPathForLang(basePath: string, _lang: Language): string {
  const clean = stripLangPrefix(basePath);
  return clean ? `/${clean}` : '/';
}

/** Returns the canonical path used for SEO lookups (no language prefix). */
export function getBasePathFromUrl(urlPath: string): string {
  const clean = stripLangPrefix(urlPath);
  return clean ? `/${clean}` : '/';
}

/** Legacy: site is single-language now, target language is ignored. */
export function switchLanguageUrl(currentPath: string, _targetLang: Language): string {
  return getBasePathFromUrl(currentPath);
}
